import React, { FC, useContext, useState } from "react";
import { menuItems } from "../../../common/constants/dashboard.constants";
import { UserContext } from "../../../contexts/userContext";
import { getTrimmedPublicKey } from "../../../utilities/helpers";
import SidebarMenuItem from "./SidebarMenuItem/SidebarMenuItem";
import userSettings from "../../../assets/userWhite.svg";
import dashboard from "../../../assets/settingsIcon.svg";
import "./SidebarMenu.scss";
import clubAvatar from "../../../assets/clubAvatar.png";
import { EMPTY_STRING } from "../../../common/constants/common.constants";
import { DashboardActiveStep } from "../../../common/enums/dashboard.enums";
import { dashboardStore } from "../../../contexts/dashboardStore";

const SidebarMenu: FC = () => {
  const { user, isXnft } = useContext(UserContext);
  const { setActiveStep, activeStep } = dashboardStore();

  const [isSidebarMenuVisible, toggleIsSidebarMenuVisible] = useState(true);

  return (
    <div className="sidebar-menu">
      {user && (
        <div className="sidebar-menu__header">
          <img
            src={
              user?.imageUrl && user?.imageUrl !== EMPTY_STRING
                ? user.imageUrl + `?${Math.random()}`
                : clubAvatar
            }
            alt="userAvatar"
          />
          <p className="sidebar-menu__message">
            Hi,{" "}
            <span className="sidebar-menu__name-pubkey">
              {user?.name !== EMPTY_STRING
                ? user.name.toString()
                : getTrimmedPublicKey(user?.pubKey!).toString()}
            </span>
            , welcome to your User dashboard
          </p>
        </div>
      )}
      {!isXnft && (
        <div className="sidebar-menu__items">
          <div
            onClick={() => setActiveStep(DashboardActiveStep.Account)}
            className={`${
              activeStep === DashboardActiveStep.Account
                ? "sidebar-menu__account-item sidebar-menu__account-item--active"
                : "sidebar-menu__account-item "
            }`}
          >
            <img src={userSettings} alt="userSettings" />
            <p>Account settings</p>
          </div>
          <div
            className={`${
              isSidebarMenuVisible
                ? "sidebar-menu__main-item"
                : "sidebar-menu__main-item sidebar-menu__main-item--rounded-down"
            }`}
            onClick={() =>
              toggleIsSidebarMenuVisible((prevValue) => !prevValue)
            }
          >
            <img src={dashboard} alt="" />
            <p>Dashboard</p>
          </div>
          {isSidebarMenuVisible &&
            menuItems.map((item, index) => {
              return (
                <SidebarMenuItem
                  menuItem={item}
                  key={item.title}
                  isRounded={index === menuItems.length - 1}
                />
              );
            })}
        </div>
      )}
      {/* <button className="sidebar-menu__export-data">
        Export transaction Data
      </button> */}
    </div>
  );
};

export default SidebarMenu;
